'use client';

import * as React from 'react';
import { useState } from 'react';
import { Alignment, cn, TMenuItem, TMenuProps } from 'types';
import { Icon, IconType } from '../icons';

export const Menu = (props: Partial<TMenuProps>) => {
  const {
    align = Alignment.LEFT,
    items = [],
    icon = IconType.Menu,
    triggerIconSize,
    itemIconSize,
    className = '',
    headerClassName = '',
    itemClassName = '',
  } = props;
  const [isPanelVisible, setIsPanelVisible] = useState(false);

  const onSelect = (item: TMenuItem) => {
    if (typeof props.callback === 'function') {
      props.callback(item);
    }
    if (typeof item.onSelect === 'function') {
      const context = item?.context || null;
      item.onSelect(context);
    }
    setIsPanelVisible(false);
  };

  const onToggleMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setIsPanelVisible(!isPanelVisible);
  };

  return (
    <>
      <div className={cn('menuToggle cursor-pointer flex items-center', className)} onClick={onToggleMenu}>
        <Icon icon={icon} width={triggerIconSize?.width} height={triggerIconSize?.height} />
      </div>
      {isPanelVisible ? (
        <>
          <div
            onClick={() => setIsPanelVisible(false)}
            className="backdrop fixed top-0 left-0 z-10 h-screen w-screen"
          />
          <div className="menuPanelWrapper relative">
            <div
              className={cn(
                'absolute z-[11] overflow-hidden rounded-2xl bg-white shadow-lg shadow-charcoal/20',
                align === Alignment.LEFT ? 'left-0' : 'right-0'
              )}
            >
              <header
                className={cn(
                  'flex items-center bg-indigo/20 text-[1.125rem] font-semibold leading-[160%] px-5 py-3',
                  headerClassName
                )}
              >
                Menyvalg
              </header>

              {items.map((item, index) => (
                <div
                  onClick={() => onSelect(item)}
                  className={cn(
                    'flex items-center gap-4 cursor-pointer hover:bg-indigo/10 font-bold px-5 py-3',
                    itemClassName
                  )}
                  key={index}
                >
                  <Icon icon={item.icon} width={itemIconSize?.width} height={itemIconSize?.height} />
                  <span className="w-full text-left">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};
